import { ThemeOptions } from '@mui/material/styles'

const baseTheme = {
  typography: {
    fontFamily: '"Libre Franklin", Arial, sans-serif',
    button: {
      textTransform: 'none' as const,
    },
  },
  palette: {
    primary: {
      main: '#8A348A',
    },
    secondary: {
      main: '#FF6F00',
    },
    success: {
      main: '#2E7D32',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
  },
}

export const themeOptions: ThemeOptions = {
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    mode: 'light',
    background: {
      default: '#F5F5FA',
    },
  },
  components: {
    ...baseTheme.components,
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: '#8A348A',
        },
      },
    },
  },
}

export const darkThemeOptions: ThemeOptions = {
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    mode: 'dark',
  },
}
